const consultationType = [
   { value: 'VIRTUAL_GUARD', name: 'Guardia virtual' },
   { value: 'APPOINTMENT', name: 'Turno programado' },
];

export default consultationType;
